var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path2, _ellipse, _path3, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle2, _path4, _ellipse2, _path5, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle3, _path6, _ellipse3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuneralDirector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "167.915 149.814 146.001 109",
    width: 146.001,
    height: 109,
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.156 192.187c6.939 9.525 12.835 22.175 8.213 33.16-2.45 5.827-8.137 10.831-7.825 17.685.332 7.2 6.497 11.772 12.492 13.745 4.868 1.595 9.851.892 14.812 1.844 7.609 1.46 20.221-5.86 28.063-5.205 10.199.02 18.678 7.505 32.026 3.361 13.347-4.144 15.554-8.182 25.708-19.948 7.031-3.922 31.753-6.215 26.559-16.248-5.195-10.033-16.404-12.887-22.653-21.851-13.279-8.405 16.404-29.442-6.249-43.703-19.581-12.326-27.974.393-35.151 5.603-10.138 7.37-18.599 19.977-30.437 16.41-7.08-2.131-12.98-9.731-19.997-12.07-8.121-2.709-17.44-1.049-24.264 4.318-3.74 2.944-6.894 7.449-6.506 12.35.322 4.006 2.886 7.355 5.209 10.549z",
    fill: "#2D9BDB",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.441,
    y: 214.116,
    width: 8.265,
    height: 34.344,
    rx: 2.71,
    ry: 2.71,
    fill: "#d8d8d8",
    paintOrder: "fill"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 207.668,
    y: 215.166,
    width: 3.989,
    height: 33.295,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#e8e9e3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199.749,
    y: 243.748,
    width: 15.986,
    height: 7.942,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#f4bd50"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200.478,
    y: 243.855,
    width: 14.297,
    height: 2.595,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#fdcf69"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 194.532,
    y: 249.088,
    width: 25.521,
    height: 7.942,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#f4bd50"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 195.696,
    y: 249.195,
    width: 22.823,
    height: 2.595,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#fdcf69"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.504,
    cy: 207.822,
    fill: "#fdcf69",
    r: 3.828
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.623 196.737q.82-2.698 1.64 0l2.501 8.231q.82 2.698-.82 2.698h-5.002q-1.64 0-.82-2.698z",
    fill: "#fdcf69"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.666,
    cy: 210.289,
    rx: 2.522,
    ry: 1.983,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.085 204.547q.54-1.398 1.08 0l1.648 4.263q.54 1.398-.54 1.398h-3.296q-1.08 0-.54-1.398z",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 233.336,
    y: 187.37,
    width: 8.265,
    height: 61.09,
    rx: 2.71,
    ry: 2.71,
    fill: "#d8d8d8",
    paintOrder: "fill"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 237.563,
    y: 189.239,
    width: 3.989,
    height: 59.221,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#e8e9e3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 229.643,
    y: 243.748,
    width: 15.986,
    height: 7.942,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#f4bd50"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 230.373,
    y: 243.855,
    width: 14.297,
    height: 2.595,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#fdcf69"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 224.427,
    y: 249.088,
    width: 25.521,
    height: 7.942,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#f4bd50"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 225.591,
    y: 249.195,
    width: 22.823,
    height: 2.595,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#fdcf69"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.399,
    cy: 180.432,
    fill: "#fdcf69",
    r: 3.828
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.518 169.346q.82-2.698 1.64 0l2.501 8.231q.82 2.698-.82 2.698h-5.002q-1.64 0-.82-2.698z",
    fill: "#fdcf69"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.561,
    cy: 182.898,
    rx: 2.522,
    ry: 1.983,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.98 177.156q.54-1.398 1.08 0l1.648 4.263q.54 1.398-.54 1.398h-3.296q-1.08 0-.54-1.398z",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 264.565,
    y: 199.314,
    width: 8.265,
    height: 49.147,
    rx: 2.71,
    ry: 2.71,
    fill: "#d8d8d8",
    paintOrder: "fill"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 268.792,
    y: 200.817,
    width: 3.989,
    height: 47.644,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#e8e9e3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 260.873,
    y: 243.748,
    width: 15.986,
    height: 7.942,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#f4bd50"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 261.602,
    y: 243.855,
    width: 14.297,
    height: 2.595,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#fdcf69"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 255.656,
    y: 249.088,
    width: 25.521,
    height: 7.942,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#f4bd50"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 256.82,
    y: 249.195,
    width: 22.823,
    height: 2.595,
    rx: 2.71,
    ry: 2.71,
    paintOrder: "fill",
    fill: "#fdcf69"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 268.628,
    cy: 192.882,
    fill: "#fdcf69",
    r: 3.828
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.747 181.796q.82-2.698 1.64 0l2.501 8.231q.82 2.698-.82 2.698h-5.002q-1.64 0-.82-2.698z",
    fill: "#fdcf69"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.79,
    cy: 195.348,
    rx: 2.522,
    ry: 1.983,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.209 189.606q.54-1.398 1.08 0l1.648 4.263q.54 1.398-.54 1.398h-3.296q-1.08 0-.54-1.398z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/funeralDirector.2726d3e2.svg";
export { SvgFuneralDirector as ReactComponent };